/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

import { hasClass } from '@/js/utils/css'

/**
 * Close the mobile menu when the backdrop is clicked. Bound once at boot to
 * `document` — NOT `document.body`, which Turbo Drive replaces on every
 * navigation (a body-bound handler dies with the first swap).
 *
 * @type {Module}
 */
export default function init() {
    document.addEventListener('click', (e) => {
        if (!hasClass(document.body, 'menu--open')) {
            return
        }

        if (e.target && e.target.id === 'menu-backdrop') {
            document.body.classList.remove('menu--open')
            e.preventDefault()
            e.stopPropagation()
        }
    })
}
